const cleanId = (name) => {
  return name.replace(/[^a-z0-9]/gmi, "-").replace(/\s+/g, "-").toLowerCase();
};

const sortCharacters = (characters, field, numeric = false) => {
  return characters.map((c) => {
    c.clean_id = cleanId(c.name);
    return c;
  }).sort((a, b) => {
    if (numeric) {
      return a[field] > b[field];
    }
    return ('' + a[field]).localeCompare(b[field]);
  });
};

const getRelationship = (character_1, character_2) => {
  if (character_1.id == character_2.id) {
    return null;
  }
  const id = character_2.id;
  const relationships = character_1.relationships;
  if (id in relationships) {
    let relationship = relationships[id];
    relationship.characters = [character_1, character_2];
    return relationship;
  }
  return null;
}

exports.sortCharacters = sortCharacters;
exports.getRelationship = getRelationship;